import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, StateUtils, submissionViewModel) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();

    ctrl.init = function () {
        $scope.questionSets = submissionVM.lobData.homeowners.preQualQuestionSets.value;
    };

    ctrl.next = function (flowNextFn, form) {
        // prequal question requiredness not captured in the submission model, so pass form validity for isValid check
        flowNextFn(submissionVM, form.valid);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/controllers/HOPrequalQuestionsCtrl.js
// module id = 2150
// module chunks = 0